'use client'
import { MainFooter } from '@mercedes-benz/oneweb-next-react-components'
import { useCallback, useEffect } from 'react'
import { globalData } from '@/store'
import { useAtom } from 'jotai'
import { useEffectOnce } from 'react-use'

const GlobalFooter = () => {
  const [{ footer }, setGlobalData] = useAtom(globalData)

  useEffect(() => {
    fetch('/api/global-data?fields=footer')
      .then((res) => res.json())
      .then((data) => {
        setGlobalData((prev: any) => ({ ...prev, ...data.data }))
        requestAnimationFrame(() => {
          calcContentHeight()
        })
      })
  }, [setGlobalData])

  const calcContentHeight = useCallback(() => {
    const container = document.querySelectorAll('.search, .full-screen-item') as NodeListOf<HTMLElement>
    const footer = document.querySelector('footer') as HTMLElement | null

    if (container.length > 0) {
      const { bottom: footerBottom } = footer?.getClientRects().item(0) || {}
      const { clientHeight: fullHeight } = window.document.body
      if (fullHeight > (footerBottom || 0) && footer) {
        const lastContainer = container[container.length - 1]
        if (lastContainer && !lastContainer.firstElementChild?.classList.contains('absolute')) {
          const { height: lastChildHeight } = lastContainer.getClientRects().item(0) || {}
          lastContainer.style.height = `${(lastChildHeight || 0) + fullHeight - (footerBottom || 0)}px`

          const rootChild = lastContainer.childElementCount > 0 ? lastContainer.children[0] : null
          if (rootChild) {
            (rootChild as HTMLElement).style.height = `${(lastChildHeight || 0) + fullHeight - (footerBottom || 0)}px`
          }
        }
      }

    } else {
      // 如果没找到元素，延迟重试
      setTimeout(calcContentHeight, 100)
    }
  }, [])

  useEffectOnce(() => {
    // 监听 DOM 变化
    const observer = new MutationObserver(() => {
      calcContentHeight()
    })

    // 开始观察
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    })

    const handleResize = () => {
      calcContentHeight()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', handleResize)
    }
  })

  return <>
    {footer && <MainFooter {...footer} />}
  </>
}

export default GlobalFooter
